import {
  createCreationValuesSchema,
  type CreateFieldOptions,
  type CreationValue,
  type CreationValues,
} from '@cims-online/shared'

export type CreateWorkflowRecordFormValues = Record<
  string,
  CreationValue | undefined
>

type CreationValuesValidation = {
  data: CreationValues | undefined
  fieldIssues: Record<string, string[]>
  formIssues: string[]
  valid: boolean
}

/**
 * Validates the whole creation form and groups shared-schema issues for Ant
 * Design's field-level presentation.
 *
 * Issues without a current creation field ID remain form-level failures so a
 * schema or configuration mismatch cannot accidentally enable submission.
 */
export function validateCreationValues(
  fields: readonly CreateFieldOptions[],
  values: CreateWorkflowRecordFormValues
): CreationValuesValidation {
  const result = createCreationValuesSchema(fields).safeParse(values)
  if (result.success)
    return {
      data: result.data,
      fieldIssues: {},
      formIssues: [],
      valid: true,
    }

  const creationFieldIds = new Set(fields.map(({ id }) => id))
  const fieldIssues: Record<string, string[]> = {}
  const formIssues: string[] = []

  for (const issue of result.error.issues) {
    const fieldId = issue.path[0]
    if (typeof fieldId === 'string' && creationFieldIds.has(fieldId))
      (fieldIssues[fieldId] ??= []).push(issue.message)
    else formIssues.push(issue.message)
  }

  return {
    data: undefined,
    fieldIssues,
    formIssues,
    valid: false,
  }
}
